module.exports = __webpack_public_path__ + "img/image004.dc41d8ec.jpg";